import { faMinus, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import "./Increment_Decrement_Btn.css";

const IncrementDecrementBtn = ({ restaurant }) => {
    const [count, setCount] = useState(1); // State to hold the count

    const handleIncrement = () => {
        setCount((prevCount) => prevCount + 1); // Increment the count
    };

    const handleDecrement = () => {
        setCount((prevCount) => (prevCount > 0 ? prevCount - 1 : 0)); // Decrement the count but not below 0
    };

    const mainClassName = `main_content_holder ${restaurant ? 'restaurant' : ''}`;

    return (
        <div className='Increment_Decrement_Btn'>
            <div className={mainClassName}>
                {/* Decrement Button */}
                <div className='icon_holder minus' onClick={handleDecrement}>
                    <FontAwesomeIcon icon={faMinus} className='icon_class' />
                </div>
                {/* Count Display */}
                <div className='count_holder'>
                    <p className='count'>{count}</p>
                </div>
                {/* Increment Button */}
                <div className='icon_holder' onClick={handleIncrement}>
                    <FontAwesomeIcon icon={faPlus} className='icon_class' />
                </div>
            </div>
        </div>
    );
};

export default IncrementDecrementBtn;
